import Axios from 'axios'

const serverUrl = 'https://api.spyder.foreplay.co'

const AxiosConfig = Axios.create({
  baseURL: serverUrl
})

export default AxiosConfig